import { Module } from "wrapper6";

var $ = jQuery;

export default class CartAutoUpdate extends Module {

    ready(app) {

        var menuCart = document.querySelector('.menu-cart-icon');
        var hasCount = menuCart.querySelector('span');
        var isHome = document.querySelector('body.home');
        var isCart = document.querySelector('body.woocommerce-cart')

        $( document ).ajaxSuccess(function( event, xhr, settings ) {

            try {
                var obj = JSON.parse(xhr.responseText);

                if (!isHome && hasCount && obj.fragments['div.widget_shopping_cart_content'] != undefined && !isCart) {
                    $('.menu-mini-cart').addClass('shoppingActive');

                    setTimeout(function(){
                        $('.menu-mini-cart').removeClass('shoppingActive');
                    }, 2500);
                }
            } catch(e) {
                
            }
        });

        $('form.checkout.woocommerce-checkout').bind('DOMSubtreeModified',function(){
            if ($('.woocommerce-NoticeGroup').length) {
                $('.woocommerce-NoticeGroup').insertAfter('.mtt-cart__safe-payment')//where you want to place it
            }
        });

    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_cart-auto-update.js